import InstallationsIcon from './component'

export default InstallationsIcon
